export const refresh_cw = () => (
  <path
    d="M23 4v6m0 0h-6m6 0l-4.64-4.36A9 9 0 003.51 9M1 20v-6m0 0h6m-6 0l4.64 4.36A9 9 0 0020.49 15"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
